


import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { notesEndpoints } from "../../../services/apis"; // Adjust the import path
import { apiConnector } from "../../../services/apiConnector"; // Adjust the import path
import { useSelector } from "react-redux";
const NotesCategoryManagement = () => {
    const { token } = useSelector((state) => state.auth);
  const [categories, setCategories] = useState([]); // Store categories
  const [formData, setFormData] = useState({ name: "", description: "" }); // Form state
  const [editMode, setEditMode] = useState(false); // To toggle between Create and Edit
  const [currentCategoryId, setCurrentCategoryId] = useState(null); // ID of category being edited

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await apiConnector("GET", notesEndpoints.NOTES_CATEGORIES_API, null, {
        Authorization: `Bearer ${token}`,
      });

      if (response?.data?.success) {
        setCategories(response.data.data);
      } else {
        throw new Error(response?.data?.message || "Could not fetch categories");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const toastID = toast.loading("Processing...");

    try {
      if (editMode) {
        // Update category
        const response = await apiConnector(
          "PUT",
          `${notesEndpoints.UPDATE_NOTES_CATEGORY_API}/${currentCategoryId}`,
          formData,
          {
            Authorization: `Bearer ${token}`,
          }
        );

        if (response?.data?.success) {
          toast.success("Category updated successfully");
        } else {
          throw new Error(response?.data?.message || "Could not update category");
        }
      } else {
        // Create category
        const response = await apiConnector(
          "POST",
          notesEndpoints.CREATE_NOTES_CATEGORY_API,
          formData,
          {
            Authorization: `Bearer ${token}`,
          }
        );

        if (response?.data?.success) {
          toast.success("Category created successfully");
        } else {
          throw new Error(response?.data?.message || "Could not create category");
        }
      }

      fetchCategories(); // Refresh categories list
      setFormData({ name: "", description: "" }); // Reset form
      setEditMode(false);
      setCurrentCategoryId(null);
    } catch (error) {
      toast.error(error.message);
    }
    toast.dismiss(toastID);
  };

  const handleEdit = (category) => {
    setFormData({ name: category.name, description: category.description });
    setEditMode(true);
    setCurrentCategoryId(category._id);
  };

  const handleDelete = async (categoryId) => {
    const toastID = toast.loading("Deleting...");

    try {
      const response = await apiConnector(
        "DELETE",
        `${notesEndpoints.DELETE_NOTES_CATEGORY_API}/${categoryId}`,
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (response?.data?.success) {
        toast.success("Category deleted successfully");
        fetchCategories(); // Refresh categories list
      } else {
        throw new Error(response?.data?.message || "Could not delete category");
      }
    } catch (error) {
      toast.error(error.message);
    }
    toast.dismiss(toastID);
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Notes Category</h1>

      {/* Form Section */}
      <div className="bg-white p-4 rounded shadow-md">
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700">Category Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border rounded"
              placeholder="Enter category name"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border rounded"
              placeholder="Enter category description"
              required
            ></textarea>
          </div>
          <button
            type="submit"
            className={`px-4 py-2 rounded text-white ${
              editMode ? "bg-blue-500 hover:bg-blue-700" : "bg-blue-500 hover:bg-blue-700"
            }`}
          >
            {editMode ? "Update Category" : "Create Category"}
          </button>
          {editMode && (
            <button
              type="button"
              onClick={() => {
                setEditMode(false);
                setFormData({ name: "", description: "" });
              }}
              className="ml-4 px-4 py-2 rounded bg-pure-greys-500 hover:bg-pure-greys-700 text-white"
            >
              Cancel
            </button>
          )}
        </form>
      </div>

      {/* Categories List Section */}
      <div className="mt-8">
        <h2 className="text-xl font-bold mb-4">Notes Categories List...</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((category) => (
            <div key={category._id} className="bg-white p-4 rounded shadow-md">
              <h3 className="text-lg font-bold">{category.name}</h3>
              <p className="text-pure-greys-600">{category.description}</p>
              <div className="mt-4 flex justify-between">
                <button
                  onClick={() => handleEdit(category)}
                  className="px-4 py-2 bg-blue-500 hover:bg-blue-700 text-white rounded"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(category._id)}
                  className="px-4 py-2 bg-pink-500 hover:bg-pink-700 text-white rounded"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotesCategoryManagement;
